module.exports = __webpack_public_path__ + "fonts/joszaki.08162a3.woff";